import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import http from 'axios'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import Products from './components/Products'
import { saveAccess } from 'core/lib'

function ProductsList({ classes }) {
	const dispatch = useDispatch()
	const categoryParam = useParams()['*']
	const { categoriesArray, products } = useSelector(state => state.products)
	/*
	 * Per riportare l'utente alla posizione precedente quando ritorna alla lista imposto un'altezza del contenitore molto alta,
	 * altrimenti quando il browser tenta di effettuare lo scroll i dati non sono acnora caricati e quella posizione non esiste nella pagina.
	 * Dopo il load dei prodotti imposto l'altezza su 'auto' così il contenitore si adatta al contenuto
	 */
	const [fakeHeight, setFakeHeight] = useState(50000)

	useEffect(() => {
		const loadProducts = async() => {
			const myCategory = categoriesArray.filter(c => c.ecom_url == categoryParam)
			if (myCategory.length == 1) {
				const categoryId = myCategory[0].category_id
				const products = await http.get(`${window.__endpoint}/api/category/${categoryId}`)
				dispatch({ type: 'loadProducts@products', products: products })

				// Imposto l'altezza giusta del container
				setFakeHeight('auto')

				// Salvo l'accesso
				saveAccess('category', categoryId)
			}
		}

		// Se cambia la categoria selezionata o al completamento del load delle categorie eseguo il caricamento dei prodotti
		dispatch({ type: 'loadProducts@products', products: null })
		loadProducts()
	}, [categoryParam, categoriesArray])

	return (<div className={classes.page} style={{ height: fakeHeight }}>
		{categoriesArray.length > 0 && <div>
			<h3 className={classes.pageTitle}>{categoriesArray.filter(c => c.ecom_url == categoryParam)[0].name}</h3>
			{/* <h3 className={classes.pageSubTitle}>{categoriesArray.filter(c => c.ecom_url == categoryParam)[0].html_description}</h3> */}
			<h3 className={classes.pageSubTitle} dangerouslySetInnerHTML={{
				__html: categoriesArray.filter(c => c.ecom_url == categoryParam)[0].html_description
			}}></h3>

			<Products
				products={products}
			/>
		</div>}
	</div>)
}

export default withStyles(style)(ProductsList)
